const validateRoutes = [
  {
    name: 'Confirm',
    path: 'confirm',
    meta: {
      layout: 'SIDE_ONLY',
    },
  },
  {
    name: 'Done',
    path: 'done',
    meta: {
      layout: 'SIDE_ONLY',
      hideActionBar: true,
      disableNavBar: true,
    },
  },
];

const childrens = [
  ...validateRoutes.map(elem => ({
    path: elem.path,
    component: elem.name,
    name: `validate${elem.name}`,
    meta: elem.meta,
  })),
];

export default childrens;
